module.exports = __webpack_public_path__ + "img/所获荣誉@2x.e070c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/所获荣誉@2x.png
// module id = 92V6
// module chunks = 3